import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent  {
  message: string;
  title: string;
  status: string;
  btnText: string;
  callback: () => void;

  constructor(protected ref: NbDialogRef<ConfirmationDialogComponent>) {
    this.status = this.status || 'primary';
  }

  cancel() {
    this.ref.close(false);
  }

  submit() {
    if(this.callback){
      this.callback();
    }

    this.ref.close(true);
  }
}
